import { combineReducers } from "@reduxjs/toolkit";
import analysisSlice from "./analysis/analysisSlice";
import globalSlice from "./global/globalSlice";
import productSlice from "./product/productSlice";
import selfieSlice from "./selfie/selfieSlice";
import styleSlice from "./style/styleSlice";
import termsSlice from "./terms/termsSlide";
import volumeSlice from "./volume/volumeSlice";

// export const store = configureStore({
//   reducer: {
//     style: styleSlice,
//     volume: volumeSlice,
//     terms: termsSlice,
//     selfie: selfieSlice,
//     global: globalSlice,
//     product: productSlice,
//     analysis: analysisSlice,
//   },
// });

// export type AppDispatch = typeof store.dispatch;

// export default store;

// import { combineReducers } from 'redux'

const rootReducer = () => (state: any, action: never) => {
  const combinedReducer = combineReducers({
    style: styleSlice,
    volume: volumeSlice,
    terms: termsSlice,
    selfie: selfieSlice,
    global: globalSlice,
    product: productSlice,
    analysis: analysisSlice,
  });
  return combinedReducer(state, action);
};

export default rootReducer;
